import React from 'react';
import '../css/expandable-filter.sass';
import filterImg from '../css/assets/img/filter.svg';

interface ExpandableFilterProps {
  children: React.ReactNode;
  showHorizontalLine?: boolean;
  onBlur?: Function;
}

interface ExpandableFilterState {
  isExpanded: boolean;
}

export default function ExpandableFilter(props: ExpandableFilterProps) {
  const { showHorizontalLine = false } = props;

  const expFilterRef: any = React.useRef(null);
  const [state, setState] = React.useState<ExpandableFilterState>({
    isExpanded: false,
  });

  const handleKeyDown = (e: any) => {
    if (e.keyCode === 27 || e.key === 'Escape') {
      setState({ ...state, isExpanded: false });
      if (props.onBlur !== undefined) {
        props.onBlur();
      }
    }
  };

  React.useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [expFilterRef]);
  return (
    <div className="expandable-filter" ref={expFilterRef}>
      <img
        className="expandable-filter-icon"
        id="filter-content"
        src={filterImg}
        alt="filter details"
        onClick={() => setState({ isExpanded: !state.isExpanded })}
        onMouseDown={(e) => {
          e.preventDefault();
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === 'Space') {
            setState({ ...state, isExpanded: !state.isExpanded });
          }
        }}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
        role="button"
        aria-label={state.isExpanded ? `Hide filters` : `Show filters`}
        tabIndex={0}
      />
      {state.isExpanded && (
        <>
          {showHorizontalLine && <div className="expandable-filter-divider" />}
          <div className="expandable-filter-items">{props.children}</div>
        </>
      )}
    </div>
  );
}
